import React from 'react';
import { CameraOutlined } from '@ant-design/icons';
import { Divider, message, Space, Spin, Typography } from 'antd';
import Config from '../../../config/Config';
import WidgetAjax from '../../../widget/WidgetAjax';
import WidgetMessage from '../../../widget/WidgetMessage';

const filePath = Config.getFilePath();

const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];
const ALLOWED_EXTS = ['png', 'jpg', 'jpeg'];
const MAX_SIZE_MB = 5;

const validateFile = (file) => {
  if (!file) return '请选择文件';
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  if (!ALLOWED_EXTS.includes(ext) || !ALLOWED_TYPES.includes(file.type)) {
    return `仅支持上传 ${ALLOWED_EXTS.join(', ')} 格式的图片`;
  }
  if (file.size / 1024 / 1024 > MAX_SIZE_MB) {
    return `文件大小不能超过 ${MAX_SIZE_MB}MB`;
  }
  return '';
};

/**
 * 简历头部: 头像 + 姓名 + 联系方式
 * - 点击头像触发文件选择 -> applicant/logo_import
 * - 上传成功后调用 props.onUploaded() 让父页面重新拉数据刷新头像
 * - 上传过程中 avatar 上叠加 uploading 状态
 */
class ResumeHeader extends React.Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      uploading: false,
    };
  }

  openPicker = () => {
    const { applicantId } = this.props;
    if (!applicantId) {
      message.warning('请先登录后再上传头像');
      return;
    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleFileChange = (event) => {
    const { applicantId, onUploaded } = this.props;
    const file = event.target.files && event.target.files[0];
    // 允许同文件二次选择
    if (event.target) event.target.value = '';

    if (!file) return;

    const error = validateFile(file);
    if (error) {
      WidgetMessage.error(error);
      return;
    }

    const formData = new FormData();
    formData.append('id', applicantId);
    formData.append('file', file);

    this.setState({ uploading: true });

    try {
      WidgetAjax.uploadFile({
        url: Config.getBasePath() + '/applicant/logo_import',
        formData,
        callback: (res) => {
          // 接口返回 (无论成功或失败) 都关闭 uploading 状态
          this.setState({ uploading: false });
          if (res && res.status === 0) {
            WidgetMessage.success('头像上传成功');
            if (typeof onUploaded === 'function') {
              onUploaded(res);
            }
          } else {
            WidgetMessage.error((res && res.message) || '头像上传失败');
          }
        },
      });
    } catch (e) {
      this.setState({ uploading: false });
      WidgetMessage.error((e && e.message) ? e.message : '头像上传失败');
    }
  };

  render() {
    const { info = {}, loading, applicantId } = this.props;
    const { uploading } = this.state;

    const hasLogo = info.LOGO && info.LOGO.length > 0 && info.id;
    const logoSrc = hasLogo
      ? `${filePath}applicant/${info.id}/M${info.LOGO[0]}.png`
      : require('../../../img/dataSource/no-img.png');

    const canEdit = Boolean(applicantId);

    return (
      <div className="resume-new-header">
        <div className="resume-new-header-inner">
          <div className="resume-new-header-avatar-wrap">
            <Spin size="small" spinning={loading || uploading}>
              <img
                src={logoSrc}
                alt="头像"
                className={`resume-new-header-avatar ${canEdit ? 'is-editable' : ''}`}
                onClick={canEdit ? this.openPicker : undefined}
                title={canEdit ? '点击上传头像' : undefined}
              />
            </Spin>
            {canEdit ? (
              <div className="resume-new-header-avatar-mask" onClick={this.openPicker}>
                <CameraOutlined />
                <span>更换头像</span>
              </div>
            ) : null}
            {/* 隐藏的 file input, 点击触发 */}
            <input
              ref={this.fileInputRef}
              type="file"
              accept="image/png,image/jpeg"
              style={{ display: 'none' }}
              onChange={this.handleFileChange}
            />
          </div>
          <div className="resume-new-header-info">
            <div className="resume-new-header-name">{info.PERNAME || '-'}</div>
            <div className="resume-new-header-tags">
              <Space split={<Divider type="vertical" />}>
                {info.SEX_CN ? <Typography.Text>{info.SEX_CN}</Typography.Text> : null}
                {info.AGE ? <Typography.Text>{info.AGE}</Typography.Text> : null}
                {info.RESADDRESS ? <Typography.Text>{info.RESADDRESS}</Typography.Text> : null}
                {info.IDENTITY_CN ? <Typography.Text>{info.IDENTITY_CN}</Typography.Text> : null}
              </Space>
            </div>
            <div className="resume-new-header-contact">
              <Space>
                <Typography.Text>{info.CELL || '-'}</Typography.Text>
                <Typography.Text>{info.EMAIL || '-'}</Typography.Text>
              </Space>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ResumeHeader;